export default __webpack_public_path__ + "static/media/monk@2x.3741630f.webp";